import PropTypes from 'prop-types';
import React from 'react';

import Box from '../components/Box';

const LineClamp = ({ children, lines, attributes: { sx: userSx, ...restAttributes } = {} }) => (
  <Box
    component="span"
    sx={{
      // Outer Box: handles parent container requirements
      display: 'block',
      overflow: 'hidden',
      minWidth: 0, // Critical for flexbox children
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
    }}
  >
    <Box
      component="span"
      sx={[
        {
          // Inner Box: handles the actual line clamping
          display: '-webkit-box',
          WebkitLineClamp: lines,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
        },
        ...(Array.isArray(userSx) ? userSx : [userSx]),
      ]}
      {...restAttributes}
    >
      {children}
    </Box>
  </Box>
);

LineClamp.propTypes = {
  /**
   * The children to be clamped.
   */
  children: PropTypes.node.isRequired,
  /**
   * The number of lines to clamp the children to.
   */
  lines: PropTypes.number.isRequired,
  /**
   * Additional attributes to pass to the Box component.
   */
  attributes: PropTypes.object,
};

export default LineClamp;
